import { Tag as AntTag, TagProps } from "antd";
import cn from "classnames";
import { FC } from "react";

import styles from "./Tag.module.scss";

type Props = TagProps & {
  size?: "xs" | "sm" | "md";
  className?: string;
};

export const Tag: FC<Props> = ({
  size = "md",
  className,
  children,
  ...props
}) => {
  return (
    <AntTag {...props} data-size={size} className={cn(styles.tag, className)}>
      {children}
    </AntTag>
  );
};
